import * as React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { StepConnector, stepConnectorClasses, styled } from '@mui/material';
import { validatePassword } from '../../utils/utils';
import { ProfileFieldProps } from '../types';

const SetupStepConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    left: 'calc(-40%)',
    right: 'calc(60%)',
  },
}));

/**
 * Displays the setup stepper.
 */
export const SetupStepper = ({
  profile,
  steps,
  activeStep,
  setActiveStep,
}: {
  profile: ProfileFieldProps['profile'];
  steps: string[];
  activeStep: number;
  setActiveStep: (step: number) => void;
}) => {
  // The handler for the stepper. If the user is in the first step (password) and
  // the password is valid, enable the second step (profile). If the user is in
  // the second step, the user can click on the first step to go back.
  const handleStep = (step: number) => {
    if (validatePassword(profile.password, profile.confirmPassword))
      setActiveStep(step);
  };

  return (
    <Stepper
      sx={{
        width: '50%',
        marginBottom: '56px',
      }}
      activeStep={activeStep}
      alternativeLabel
      connector={<SetupStepConnector />}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            sx={{
              '&:hover': {
                cursor:
                  activeStep >= index ||
                  (index == 1 &&
                    validatePassword(profile.password, profile.confirmPassword))
                    ? 'pointer'
                    : 'default',
              },
            }}
            onClick={() => {
              handleStep(index);
            }}
          >
            {activeStep == index ? label : ''}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};
